import colors from 'lib/colors';
import { cover } from 'polished';
import Flex from './Flex';

const Background = () => (
  <Flex
    zIndex={-1}
    css={{
      ...cover(),
      position: 'fixed',
      backgroundColor: colors.blueBackground,
    }}
  />
);

export default Background;
